/**
 * Utility to allow checking for whether a function/switch has exhaustively covered all possible types of a value
 * @param value variable to check coverage on
 */
export function exhaustiveCheck(value) {
    throw new Error(`Should never get called, got called with ${value}`);
}
//# sourceMappingURL=exhaustive_check.js.map